/**
 * Читання non-HttpOnly cookie з `document.cookie` (ADR-0006 D3).
 *
 * Використовується CSRF request-interceptor'ом для cookie `csrf` (ADR-0002 D4):
 * читаємо щоразу (cookie змінюється на login/logout), не кешуємо. HttpOnly
 * `session`-cookie тут НЕ видно за дизайном — нею керує сервер.
 */
export function readCookie(name: string): string | null {
  const prefix = `${encodeURIComponent(name)}=`;
  const parts = document.cookie ? document.cookie.split("; ") : [];
  for (const part of parts) {
    if (part.startsWith(prefix)) {
      return decodeURIComponent(part.slice(prefix.length));
    }
  }
  return null;
}
